<template>
  <div>
    <el-dialog :close-on-click-modal="false" title="Select Product"
      v-if="visible" :model-value="visible" @update:modelValue="(val) => { if (!val) modal.closeProduct(); visible = val }" width="50%">
      <el-row :gutter="20">
        <el-col :span="8">
          <el-input v-model="searchQuery" v-no-space style="margin-bottom: 20px" placeholder="Search Lot No / SKU" />
        </el-col>
        <el-button type="primary" @click="handleSearchInput">Search</el-button>
      </el-row>
      <el-table :data="productList" @row-click="handleSelect" stripe v-loading="listLoading" header-cell-class-name="my-header">
        <el-table-column label="Photo" width="140" align="center">
          <template #default="scope">
            <img v-if="scope" :src="scope.row.pic" alt="Photo" style="width: 45px; height: 45px;" />
          </template>
        </el-table-column>
        <el-table-column prop="refNo" label="LotNo / SKU" />
        <el-table-column prop="name" label="Name" />
        <el-table-column label="" align="right">
          <template #default="scope">
            <el-button v-if="scope" size="small" type="primary" @click.stop="handleSelect(scope.row)">Select</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template #footer>
        <el-button @click="modal.closeProduct(); visible = false">Cancel</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'
import { fetchProductForVoucher as fetchProductList } from '@/api/voucher'
import { useModalStore } from '@/stores/modal'

const modal = useModalStore()

const visible = ref(false)
const searchQuery = ref('')
const inventoryType = ref(null)
const place = ref(null)
const productList = ref([])
const listLoading = ref(false)

watch(() => modal.product.visible, (val) => {
  if (val) {
    const params = modal.product.data
    inventoryType.value = params?.inventoryType ?? null
    place.value = params?.place ?? null
    searchQuery.value = ''
    productList.value = []
    visible.value = true
  } else {
    visible.value = false
  }
}, { immediate: true })

async function fetchProducts(query) {
  try {
    listLoading.value = true
    const response = await fetchProductList({
      refCode: query,
      inventoryType: inventoryType.value,
      place: place.value
    })
    productList.value = response.data
  } catch (e) {
    // error handled by request interceptor
  } finally {
    listLoading.value = false
  }
}

function handleSearchInput() {
  fetchProducts(searchQuery.value)
}

function handleSelect(row) {
  modal.resolveProduct(row)
}
</script>

<style scoped>
.my-header { font-weight: bold; }
</style>
